import { createSelector } from 'reselect';

import { getAiModelsByRoleKey } from '../actions/aiModelsByRole.actions';

import { toAiModelOption } from './aiModels.selectors';
import { getSystem } from './system.selectors';

const getAiModelsByRoleState = createSelector(getSystem, ({ aiModelsByRole }) => aiModelsByRole);

export const selectAiModelsByRole = ({ role, specialistKey = null }) =>
  createSelector(getAiModelsByRoleState, ({ byKey }) => {
    const key = getAiModelsByRoleKey({ role, specialistKey });

    return (byKey[key] ?? []).map(toAiModelOption);
  });

export const selectAiModelsByRoleIsLoading = ({ role, specialistKey = null }) =>
  createSelector(getAiModelsByRoleState, ({ loadingByKey }) => {
    const key = getAiModelsByRoleKey({ role, specialistKey });

    return !!loadingByKey[key];
  });
